module.exports = __webpack_public_path__ + "static/media/distance-value-graph.be62ce54.png";